export default "__VITE_ASSET__051a33d2__"